import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/FormularioEmpresa.css';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5257';

function FormularioEmpresa() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    nombre: '',
    tipo: '',
    descripcion: '',
    direccion: '',
    telefono: '',           
    correoElectronico: ''   
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleVolver = () => {
    navigate(-1);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
   
    if (error) setError(null);
  };

  const validarDireccionParaGoogle = (direccion) => {
    if (direccion.length < 15) {
      return "La dirección es demasiado corta. Por favor incluye calle, número, colonia y ciudad.";
    }
   
    const tieneNumeros = /\d/.test(direccion);
    if (!tieneNumeros) {
      return "La dirección debe incluir al menos un número (número exterior o código postal) para ser válida.";
    }

    return null; 
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    const errorDireccion = validarDireccionParaGoogle(formData.direccion);
    if (errorDireccion) {
      setError(errorDireccion);
      setLoading(false);
      return;
    }
    
    let direccionFinal = formData.direccion.trim();
    if (!direccionFinal.toLowerCase().includes('mexico') && !direccionFinal.toLowerCase().includes('méxico')) {
        direccionFinal += ', México';
    }

    
    const dataParaEnviar = {
      nombre: formData.nombre,
      tipoIndustria: formData.tipo,
      descripcion: formData.descripcion,
      direccion: direccionFinal, 
      telefono: formData.telefono,
      correoElectronico: formData.correoElectronico
    };

    try {
      const response = await fetch(`${API_BASE_URL}/api/solicitudes`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataParaEnviar),
      });

      if (response.ok) {
        alert('Solicitud enviada exitosamente para aprobación.');
        navigate('/mapa');
      } else {
        const errorData = await response.json();
        setError(errorData.message || 'Error al enviar la solicitud.');
      }
    } catch (err) {
      console.error('Error en fetch:', err);
      setError('No se pudo conectar con el servidor. Intente más tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="form-page-container">
      <div className="form-container">
        <button onClick={handleVolver} className="btn-volver">
          &lt; Volver
        </button>
        <h2>Enviar Solicitud de Registro</h2>

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="nombre">Nombre de la Empresa</label>
            <input
              type="text"
              id="nombre"
              name="nombre"
              value={formData.nombre}
              onChange={handleChange}
              placeholder="Ingrese el nombre de la empresa"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="tipo">Tipo de Industria</label>
            <select
              id="tipo"
              name="tipo"
              value={formData.tipo}
              onChange={handleChange}
              required
            >
              <option value="" disabled>
                Seleccione el tipo de industria
              </option>
              <option value="agroindustria">Agroindustria</option>
              <option value="papel">Papel</option>
              <option value="quimica">Química</option>
              <option value="puerto">Puerto</option>
            </select>
          </div>

          
          <div className="form-row" style={{ display: 'flex', gap: '15px' }}>
            <div className="form-group" style={{ flex: 1 }}>
              <label htmlFor="telefono">Teléfono</label>
              <input
                type="tel"
                id="telefono"
                name="telefono"
                value={formData.telefono}
                onChange={handleChange}
                placeholder="Ej. 55 1234 5678"
                required
              />
            </div>
            <div className="form-group" style={{ flex: 1 }}>
              <label htmlFor="correoElectronico">Correo Electrónico</label>
              <input
                type="email"
                id="correoElectronico"
                name="correoElectronico"
                value={formData.correoElectronico}
                onChange={handleChange}
                placeholder="contacto@empresa.com"
                required
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="direccion">Dirección Completa</label>
            <input
              type="text"
              id="direccion"
              name="direccion"
              value={formData.direccion}
              onChange={handleChange}
              placeholder="Calle, Número, Colonia, Ciudad, Estado, CP" 
              required
            />
            <small style={{ color: '#666', fontSize: '0.8em', marginTop: '5px', display: 'block' }}>
              Formato sugerido: Calle + Núm, Colonia, Ciudad, Estado.
            </small>
          </div>

          <div className="form-group">
            <label htmlFor="descripcion">Descripción</label>
            <textarea
              id="descripcion"
              name="descripcion"
              rows="4"
              value={formData.descripcion}
              onChange={handleChange}
              placeholder="Ingrese la descripción de la empresa"
              required
            />
          </div>

          {error && <div className="form-error" style={{ color: 'red', marginTop: '10px' }}>{error}</div>}

          <button type="submit" className="btn-submit" disabled={loading}>
            {loading ? 'Enviando...' : 'Enviar Solicitud'}
          </button>
        </form>
      </div>
    </div>
  );
}

export default FormularioEmpresa;